export type ValidationErrors = Record<string, string[]>;

/**
 * Campos extras que a API pode mandar no corpo do erro. Hoje usados no erro de
 * cartão do place-order (422): `error_code` (ex.: `card_cvv_required`) e
 * `action` (ex.: `confirm_cvv`) dizem à tela o que fazer em vez de só mostrar
 * a mensagem.
 */
export type ApiErrorDetails = {
  code?: string;
  action?: string;
};

export class ApiError extends Error {
  public readonly errors?: ValidationErrors;
  public readonly status?: number;
  public readonly code?: string;
  public readonly action?: string;

  constructor(message: string, errors?: ValidationErrors, status?: number, details?: ApiErrorDetails) {
    super(message);
    this.name = 'ApiError';
    this.errors = errors;
    this.status = status;
    this.code = details?.code;
    this.action = details?.action;
  }

  static isApiError(error: unknown): error is ApiError {
    return error instanceof ApiError;
  }
}
